export default __webpack_public_path__ + "static/media/2408025.c25764e5.webp";